export default "__VITE_ASSET__BwgJxiSm__"